<nav id="main-navigation" class="navbar navbar-expand-sm fixed-top flex-sm-nowrap d-print-none shadow">
  @if (!currentUrl.includes('/sign?token')) {
    <a class="navbar-logo" routerLink="/"> </a>
  } @else {
    <a class="navbar-logo"> </a>
  }

  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#defaultNavbar1"
    aria-controls="defaultNavbar1" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <!-- #region DocumentSigner sign page language dropdown. Exclusive to DocumentSigner. -->
  @if (!username && currentUrl.includes('/sign?token')) {
    <div class="dropdown ms-auto">
      <button type="button" class="btn dropdown-toggle user-field nav-compact-toggle" id="dropdownProfile" data-bs-toggle="dropdown"
        role="button" aria-expanded="false" [attr.aria-label]="'Commands.Menu' | translate">
        <i class="fal fa-bars fa-fw"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownProfile">
        @for (language of languages; track language) {
          <button class="dropdown-item" (click)="changeLanguage(language)"
            [class.fw-bold]="translate.currentLang === language">
            <i class="fal fa-globe-europe fa-fw"></i>
            <span class="label">
              {{'Language.types.' + (language | uppercase) | translate | titlecase}}
            </span>
          </button>
        }
        <div class="dropdown-divider"></div>
        <button class="dropdown-item" type="button" (click)="requestDocumentDownload()">
          <i class="fa-solid fa-download fa-fw"></i>
          <span class="label">
            {{ 'document-signer.document.signatures.onlyDownload' | translate }}
          </span>
        </button>
      </div>
    </div>
  }
  <!--#endregion -->

  @if (username) {
    <div class="collapse navbar-collapse" id="defaultNavbar1">
      <ul class="navbar-nav me-auto">
        <div class="d-none d-sm-none d-md-block">
          <li class="nav-item">
            <a class="nav-link active" (click)="toggle()">
              <i [ngClass]="isMenuCollapsed ? 'fas fa-angle-double-right' : 'fas fa-angle-double-left'"></i>
            </a>
          </li>
        </div>
        <li class="nav-item" routerLinkActive="active" *rbac="['sv2']">
          <a class="nav-link active" routerLink="/invoices">
            <i class="fal fa-fw fa-inbox"></i>
            <span class="nav-item-label">{{'postbox.singular' | translate |
            titlecase}}</span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *rbac="['consv3-area1']">
          <a class="nav-link active" routerLink="/archive">
            <i class="fal fa-fw fa-archive"></i>
            <span class="nav-item-label ">{{'conservation.singular' | translate |
            titlecase}}</span>
          </a>
        </li>
        @if ((['SystemsAdmin'] | rbac | async) || (['BANKING.READ'] | rbac | async)) {
          <li class="nav-item" routerLinkActive="active"
            >
            <a class="nav-link active" routerLink="/banking">
              <i class="fal fa-fw fa-building-columns"></i>
              <span class="nav-item-label">{{'banking.singular' | translate}}
              </span>
            </a>
          </li>
        }
        @if ((['SystemsAdmin'] | rbac | async) || (['DOCUMENTSIGNER.READ'] | rbac | async) || (['DOCUMENTSIGNER.CREATE'] | rbac | async)) {
          <li class="nav-item" routerLinkActive="active"
            >
            <a class="nav-link active" routerLink="/document-signer">
              <i class="fal fa-fw fa-file-signature"></i>
              <span class="nav-item-label">{{'document-signer.title' | translate}}
              </span>
            </a>
          </li>
        }
      </ul>
      @if (!router.url.includes('settings')) {
        <app-company-selector [selectedCompanyDisplay]="selectedCompanyDisplay"
          [selectedCompanyGuid]="selectedCompanyGuid" (onChangeCompany)="changeCompany($event)"
        ></app-company-selector>
      }
      <app-version-switch class="d-print-none"></app-version-switch>
      <ul class="navbar-nav flex-sm-nowrap d-print-none">
        <li class="nav-item pe-2" routerLinkActive="active">
          <a class="nav-link active px-0" [routerLink]="getCurrentHelpRoute()" id="help-not-show">
            <i class="fal fa-fw fa-question" style="vertical-align: middle;"></i>
            <span [ngClass]="{'d-none': isSmallScreen}" class="nav-link-label"
            style="vertical-align: middle;">{{'help.singular' | translate | titlecase}}</span>
          </a>
        </li>
        <li class="nav-item ps-2" routerLinkActive="active" data-featurebase-changelog (click)="openChangelogWidget()">
          <a class="nav-link active px-0" style="cursor: pointer;">
            <div style="position: relative; display: inline-block;">
              <i class="fal fa-fw fa-envelope" style="vertical-align: middle;"></i>
              @if (unreadCount > 0) {
                <span class="badge bg-secondary notification-badge">
                  {{unreadCount}}
                </span>
              }
            </div>
            <span [ngClass]="{'d-none': isSmallScreen}" class="nav-link-label" style="vertical-align: middle;">
              {{ 'news.singular' | translate | titlecase }}
            </span>
          </a>
        </li>
      </ul>
      <div class="dropdown">
        <button type="button" class="btn dropdown-toggle user-field" id="dropdownProfile" data-bs-toggle="dropdown"
          role="button" aria-expanded="false">
          <i class="fas fa-user fa-fw me-2"></i>
          <span id="userLabel" class="nav-link-label">{{username}}</span>
        </button>
        <div class="dropdown-menu dropdown-menu" aria-labelledby="dropdownProfile">
          @for (language of languages; track language) {
            <button class="dropdown-item" (click)="changeLanguage(language)"
              [class.fw-bold]="translate.currentLang === language">
              <i class="fal fa-globe-europe fa-fw"></i>
              <span class="label"> {{'Language.types.' + (language | uppercase) | translate | titlecase}}</span>
            </button>
          }
          <div class="dropdown-divider"></div>
          <a class="text-reset text-decoration-none" routerLink="/settings/my-profile">
            @if ((['area3x', 'PartnersReadAll', 'CustomersReadAll', 'BANKING.READ', 'DOCUMENTSIGNER.CREATE'] | rbac | async)) {
              <button id="btn-my-profile" class="dropdown-item"
                >
                <i class="fas fa-user fa-fw"></i>
                <span class="label"> {{'my-profile.singular' | translate | titlecase}}</span>
              </button>
            }
          </a>
          <a class="text-reset text-decoration-none" routerLink="/settings/my-profile">
            @if ((['area3x', 'PartnersReadAll', 'CustomersReadAll', 'BANKING.READ', 'DOCUMENTSIGNER.CREATE'] | rbac | async)) {
              <button id="btn-settings" class="dropdown-item"
                >
                <i class="fas fa-cog fa-fw"></i>
                <span class="label"> {{'setting.singular' | translate | titlecase}}</span>
              </button>
            }
          </a>
          @if ((['SystemsAdmin'] | rbac | async) || (['PartnersReadAll'] | rbac | async) || (['CustomersReadAll'] | rbac | async)) {
            <a
              class="text-reset text-decoration-none" routerLink="/statistics">
              @if ((['area3x'] | rbac | async)) {
                <button id="btn-statistics" class="dropdown-item">
                  <i class="fa-solid fa-chart-mixed statisticsIcon"></i>
                  <span class="label statistics"> {{'statistics.singular' | translate | titlecase}}</span>
                </button>
              }
            </a>
          }
          <div class="dropdown-divider"></div>
          <a class="text-reset text-decoration-none" href="https://get.teamviewer.com/4qv3wk2">
            <button id="btn-teamviewer" class="dropdown-item">
              <i class="fas fa-user-headset fa-fw"></i>
              <span class="label"> {{'remote-assistance.singular' | translate | titlecase}}</span>
            </button>
          </a>
          <a class="text-reset text-decoration-none"
            href="http://download.assistenzatelematica.it/FileDwn/FirmaCerta_SDK_WEB.exe">
            <button id="btn-fcSignServer" class="dropdown-item">
              <i class="fa-thin fa-signature"></i>
              <span class="label"> {{'firmaCertaServer.singular' | translate | titlecase}}</span>
            </button>
          </a>
          <a class="text-reset text-decoration-none" href="{{Partner.portalUrl}}/syncmanager/setup.exe">
            <button id="btn-logout" class="dropdown-item">
              <i class="fas fa-desktop fa-fw"></i>
              <span class="label"> {{'sync-manager.singular' | translate | titlecase}}</span>
            </button>
          </a>
          @if ((['JOBSERVICE'] | rbac | async)) {
            <a class="text-reset text-decoration-none" [href]="jobServiceUrlWithToken" target="_blank" rel="noopener noreferrer">
              <button id="btn-jobs" class="dropdown-item">
                <i class="fas fa-briefcase fa-fw"></i>
                <span class="label"> {{'jobs.singular' | translate | titlecase}}</span>
              </button>
            </a>
          }
          <div class="dropdown-divider"></div>
          <button id="btn-logout" class="dropdown-item" (click)="logout()">
            <i class="fal fa-sign-out fa-fw"></i>
            <span class="label"> {{'logout.verb' | translate | titlecase}}</span>
          </button>
        </div>
      </div>
    </div>
  }
</nav>
